import { Injectable } from '@angular/core';
import { StorageService } from '@services/core/storage.service';

@Injectable({
  providedIn: 'root'
})
export class PermissionService {

  public appHasAccess = ['admin', 'support', 'manager']; //Roles que pueden acceder a la app deben venir de la base de datos manual actualmente
  constructor(private storageService: StorageService) {}
  
  canAccess(): boolean {
    const userRole =this.storageService.getJsonValue('role')?.name ?? 'visualizador';
    return this.appHasAccess.includes(userRole);
  }
}